import { type } from 'arktype';

export const dayKeySchema = type(/^(?:0[1-9]\d{2}|[1-9]\d{3})-\d{2}-\d{2}$/).narrow((date, ctx) => {
  const parsed = new Date(`${date}T00:00:00Z`);
  return (!Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date) || ctx.mustBe('a valid calendar date');
});
